export default __webpack_public_path__ + "static/media/aws_comm_badge.ff766cf6.png";